"use strict";

;
;

(function ($) {
  var callbacks = $.Callbacks();
  callbacks.add(init);
  callbacks.fire();
  /**
   * 页面初始化的函数
   */

  function init() {
    // getBannerData();
    swiperOpr(); // 梯子改变的事件

    floorChangeEvent(); // 左边梯子随着滚轮滚动跟随的函数

    leftBarFollow(); // 吸顶函数

    suctionTop();
  } // swiper的轮播图的函数


  function swiperOpr() {
    var mySwiper = new Swiper('.swiper-container', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: true
      },
      loop: true,
      // 循环模式选项
      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    }); //鼠标滑过pagination控制swiper切换

    for (var i = 0; i < mySwiper.pagination.bullets.length; i++) {
      mySwiper.pagination.bullets[i].onmouseover = function () {
        this.click();
      };
    }

    mySwiper.el.onmouseover = function () {
      mySwiper.autoplay.stop();
      var prev_ele = mySwiper.navigation.prevEl;
      var next_ele = mySwiper.navigation.nextEl;
      $(prev_ele).stop(true).animate({
        left: 0
      });
      $(next_ele).stop(true).animate({
        right: 0
      });
    };

    mySwiper.el.onmouseout = function () {
      // 获取左右两边的按钮
      var prev_ele = mySwiper.navigation.prevEl;
      var next_ele = mySwiper.navigation.nextEl; // 给两个边的那妞设置动画隐藏效果

      $(prev_ele).stop(true).animate({
        left: -33
      });
      $(next_ele).stop(true).animate({
        right: -33
      });
      mySwiper.autoplay.start();
    };
  } // 梯子切换


  function floorChangeEvent() {
    // 1.点击梯子时候 我们是需要找到与梯子对应盒子 对应盒子距离顶部的距离没然后直接将滚动条直接设置这个高度
    // 2.当我滑动的时候， 当这个盒子刚出来的时候啊，我们需要发送一个请求去请求对应梯子的数据 然后吐过这个梯子的距离浏览器顶部的高度等于scrollTop的高度就将左侧的变为选中状态
    // 加入一个图片懒加载功能
    // 这个ajax不是我们页面一上来就去出发的 是通过这个梯子去触发的
    var shop_top_banners = $(".shop-top-banner");

    var _loop = function _loop(i) {
      if (i === shop_top_banners.length - 1) {
        // 最后一个梯子是预告的请求
        noticeRankAjax().then(function (data) {
          noticeRankRenderData(data.data.brandInfo, function () {
            setTimeout(function () {
              new Stairs({
                content_selector: ".shop-top-banner",
                stairs_selector: ".left-ladder a"
              });
              $(".wrap img").lazyload({
                // 覆盖lazyload自带的背景图片
                // placeholder: "https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=3544053956,2144358865&fm=26&gp=0.jpg",
                placeholder: "https://shop.vipstatic.com/img/te/index_v4/bbg-hash-b619a210.png?9b4f55ea",
                effect: "fadeIn",
                threshold: 400
              });
              $(".notice-shop img").lazyload({
                // 覆盖lazyload自带的背景图片
                placeholder: "https://shop.vipstatic.com/img/te/index_v4/bbg-lazy-hash-fc6d3841.png?05d68fe4",
                effect: "fadeIn",
                threshold: 400
              });
            }, 300);
          });
        });
      }

      floorShopAjax(i + 1).then(function (data) {
        renderFloorData(data, shop_top_banners[i]);
      });
    };

    for (var i = 0; i < shop_top_banners.length; i++) {
      _loop(i);
    }
  }

  function renderFloorData(data, shop_top_banner, callback) {
    // 判读状态码
    if (data.code === 200 && data.msg === "success") {
      var html = "";
      var brandInfoData = data.data.brandInfo; // 因为需要偶数左浮动奇数右浮动

      var count = 0;

      for (var attr in brandInfoData) {
        var float_str = "left";

        if (count % 2) {
          float_str = "right";
        }

        html += "<a href=\"./shop_list.html\"><div class=\"shop-item\" style=\"float: ".concat(float_str, "; margin-bottom: 20px;\"><img width=570 height=273\n                data-original=\"").concat(brandInfoData[attr].brandImage.size1, "\" alt=\"\">\n                <div class=\"brand-info\" style=\"margin-top: 20px; font-size: 18px;\">\n                    <p class=\"brandName\" style=\"color: #000000; font-weight: bold; margin-bottom: 10px;\">\n                        ").concat(brandInfoData[attr].salesName, "</p>\n                        <p style=\"color:#333333\">").concat(brandInfoData[attr].agio, "\n                            ").concat(brandInfoData[attr].activeIndexTips, "\n                        </p>\n                </div>\n            </div></a>");
        count++;
      } // 渲染到页面之中


      $(shop_top_banner).find(".shop-show-box").html(html);

      if (typeof callback === "function") {
        callback();
      }
    }
  } // 商品梯子图片展示的ajax请求


  function floorShopAjax(floorNum) {
    return $.ajax({
      url: "http://xfy196.qicp.vip/floor",
      dataType: "json",
      data: {
        floorId: floorNum,
        newDapLogic: 1,
        warehouse: "VIP_SH",
        channelId: 0,
        sortType: 1,
        areaCode: 103104,
        pagecode: "a",
        provinceName: "安徽省",
        cityName: "滁州市",
        "brandInfoExt[fields]": "activeIndexTips,displayEndtime,salesNo,brandImage,mobileImageOne,agio,salesName,brandStoreSn,vendorSaleMessage,isSpecialBanner,hiddenEndTime,iconInfo,link,brandType,pms_act_no,showTimeFrom",
        "brandInfoExt[startIndex]": 0,
        "brandInfoExt[num]": 36,
        preview: "",
        token: "",
        sell_time_from: "",
        time_from: "",
        _: Date.now()
      }
    });
  } // 左边栏scroll监听跟随的操作


  function leftBarFollow() {
    var t = null;
    var left_bar_top = $(".left-ladder").offset().top; // 滚动监听

    $(document).scroll(function () {
      if (typeof t === "number") {
        return false;
      } // 函数节流


      t = setTimeout(function () {
        t = null;
        var body_scrollTop = $("body,html").scrollTop();

        if (left_bar_top <= body_scrollTop) {
          $(".left-ladder").css({
            position: "fixed",
            top: "10%"
          });
        } else {
          $(".left-ladder").css({
            position: "absolute",
            // 需要减去nav的高度应为nav菜单栏是固定定位了
            top: 1600
          });
        }
      }, 100);
    });
  } // 吸顶操作


  function suctionTop() {
    // 找到nav菜单的元素节点
    var nav_ele = $(".nav"); // 获取这个元素距离页面的高度

    var scrollTop = nav_ele.offset().top + nav_ele.height();
    var slideDownCount = 0;
    var t = null;
    $(document).scroll(function () {
      // 函数节流
      if (typeof t === " number") {
        return false;
      }

      t = setTimeout(function () {}, 200);

      if (scrollTop < $("body,html").scrollTop()) {
        // 只需要让slideDown的效果执行一次即可
        if (slideDownCount > 1) {
          return;
        }

        nav_ele.css({
          width: "100%",
          position: "fixed",
          top: 0,
          left: 0,
          background: "#ffffff",
          boxShadow: "0 1px 3px 0 #a7a7a7",
          display: "none",
          "z-index": 100
        }).slideDown(function () {
          slideDownCount++;
        });
      } else {
        nav_ele.removeAttr("style"); // 回到原来的位置将slideDown的次数设置为0即可

        slideDownCount = 0;
      }
    });
  }
  /**
   * 最后预告板块的数据请求渲染
   */


  function noticeRankAjax() {
    // 发送ajax的请求
    return $.ajax({
      type: "get",
      url: "http://xfy196.qicp.vip/notice",
      data: {
        mode: "home",
        warehouse: "VIP_SH",
        areaCode: "103104",
        pagecode: "a",
        provinceName: "安徽省",
        cityName: "滁州市",
        "brandInfoExt[fields]": "activeIndexTips,salesNo,brandImage,mobileImageOne,salesName,brandStoreSn,vendorSaleMessage,warmMode,agio,storyLogo,link,brandType,pms_act_no,showTimeFrom",
        "brandInfoExt[startIndex]": 0,
        "brandInfoExt[num]": "72",
        preview: "",
        token: "",
        _: Date.now()
      },
      dataType: "json"
    });
  }

  function noticeRankRenderData(data, callback) {
    var html = "";
    var i = 0;

    for (var attr in data) {
      var marginStr = "margin:0 30px 20px 0"; // 每一行的最后一位我们需要将margin设置为0

      if ((i + 1) % 4 === 0) {
        marginStr = "margin : 0";
      }

      html += "<div style=\"".concat(marginStr, "\" class=\"brand-item\">\n            <a href=\"javascript:void(0)\"><img class=\"brand-img\" data-original=\"").concat(data[attr].brandImage.size2, "\"></a>\n            <div class=\"brand-info\">\n                <a class=\"brand-name\" href=\"javascript:void(0)\">").concat(data[attr].salesName, "</a>\n                <div class=\"pms-info\" title=\"").concat(data[attr].activeIndexTips, "\">\n                    ").concat(data[attr].activeIndexTips, "\n                </div>\n                <span class=\"brand-discount\">").concat(data[attr].agio, "\n            </div>\n            <form action=\"#\" class=\"book_form\">\n                <div class=\"book-notice-warp\">\n                    <input type=\"hidden\" value=\"").concat(data[attr].salesNo, "\" name=\"brandId\">\n                    <input type=\"text\" placeholder=\"\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801\" name=\"email-phone\" class=\"subscribe-phone\">\n                    <button type=\"submit\" class=\"book-notice-btn book-sub\">\u5F00\u552E\u63D0\u793A</button>\n                </div>\n            </form>\n        </div>");
      i++;
    }

    $(".last-show").html(html);

    if (typeof callback === "function") {
      callback();
    }
  } // banner图片数据请求函数


  function getBannerData() {
    $.ajax({
      url: "https://pcapi.vip.com/cmc/index.php",
      dataType: "jsonp",
      data: {
        type: "ADSEC56K,ADSP1Q2W,ADSZBA78,ADSIR7IX,ADSX7W3G,ADSNNLS7,ADS7JI3F,ADS2B669,ADSITG64,ADS45AV4,ADSHS93V,ADS44T33,ADS14OC5,ADSU3XLQ,ADSY2DWE,ADS3NGX5",
        warehouse: "VIP_SH",
        areaid: 103104,
        preview: 0,
        date_from: "",
        time_from: "",
        user_class: "",
        channelId: 0
      },
      success: function success(data) {
        var res = null;

        for (var attr in data) {
          if (data[attr].items.length === 0) {
            continue;
          }

          if (/ [\u4e00-\u9fa5]/.test(data[attr].items[0].name)) {
            res = data[attr];
          }
        } // 渲染数据


        if (res === null) {
          return false;
        }

        var html = "";

        for (var i = 0; i < res.items.length; i++) {
          html += "<div class=\"swiper-slide\"><a href=\"#\"><img\n                    src=\"".concat(res.items[i].img, "\" alt=\"\"></a></div><style>\n                    .swiper-pagination span:nth-of-type(").concat(i + 1, ")::after{\n                        content:\"").concat(res.items[i].name, "\";\n                    }\n                    </style>");
        }

        $(".swiper-wrapper").html(html); // 轮播图的函数

        swiperOpr();
      },
      jsonCallback: "shopAds"
    });
  } // 梯子对象


  function Stairs(options) {
    this.options = options;
    this.init();
  }

  Stairs.prototype = {
    constructor: Stairs,
    init: function init() {
      // 计算每一个内容元素的高度的数组
      this.content_ele_offset_top_list = []; // 获取元素的偏移量

      $(this.options.content_selector).offset(function (index, cords) {
        // 将每一个元素的高度值放入发哦度列表之中
        this.content_ele_offset_top_list.push(cords.top);
        return cords;
      }.bind(this)); // 计算最小高和最大高

      var _length = this.content_ele_offset_top_list.length;
      this.min_top = this.content_ele_offset_top_list[0];
      this.max_top = this.content_ele_offset_top_list[_length - 1] + $(this.options.content_selector).last().height(); // 同样我们吧这个最高的值放入数组中之后的计算需要使用

      this.content_ele_offset_top_list.push(this.max_top); // 每一次页面刷新的时候需要先计算一下梯子的位置
      // 获得数据

      var scrollTop = $("body, html").scrollTop(); // 计算下标

      this.calcStairsIndex(scrollTop);
      this.bindEvent();
    },
    bindEvent: function bindEvent() {
      var $body_html = $("body,html");
      var instance = this; // 滚动事件监听
      // 函数节流的变量

      var t = null;
      $(document).scroll(function () {
        var _this = this;

        if (typeof t === "number") {
          return false;
        }

        t = setTimeout(function () {
          t = null; // 获得数据

          var scrollTop = $body_html.scrollTop(); // 计算下标

          _this.calcStairsIndex(scrollTop);
        }, 200);
      }.bind(this)); // 点击右侧楼梯的我们需要滚动至对应的位置 绑定事件

      $(this.options.stairs_selector).click(function () {
        // 先得到点击事件元素在数组中的下标 通过这个下标找到对应的板块
        var index = $(this).index(instance.options.stairs_selector);
        instance.changeStairsIndex(index);
      });
    },
    calcStairsIndex: function calcStairsIndex(st) {
      // 如果小于最小的高度和最大的高度我们直接结束下面的函数
      if (st < this.min_top || st > this.max_top) {
        this.index = -1;
        this.changeStairsBtn();
        return false;
      }

      var _list = this.content_ele_offset_top_list; // 数据一直在这个范围之内我们就不在重复计算了

      if (st >= _list[this.index] && st < _list[this.index + 1]) {
        return false;
      } // 遍历记录滚入的楼梯的下标


      for (var i = 0; i < _list.length; i++) {
        if (st >= _list[i] && st < _list[i + 1]) {
          this.index = i;
          break;
        }
      }

      this.changeStairsBtn();
    },

    /**
     * 改变梯子的选中状态
     */
    changeStairsBtn: function changeStairsBtn() {
      if (this.index === -1) {
        $(this.options.stairs_selector).removeClass("cur");
        return false;
      } // 如果不熟index===-1 说明要选中对应下标的楼梯


      $(this.options.stairs_selector).eq(this.index).addClass("cur").siblings().removeClass("cur");
    },

    /**
     * 改变梯子选中的下标的
     * @param {点击的梯子的下标} index 
     */
    changeStairsIndex: function changeStairsIndex(index) {
      // 通过这个index我们去scroll对应的板块
      $("body,html").scrollTop(this.content_ele_offset_top_list[index]);
      $(document).trigger("scroll");
    }
  };
})(jQuery);